// extracted by mini-css-extract-plugin
export var multipleLinks = "submenus-module--multipleLinks--25e2e";
export var spanAnimated = "submenus-module--spanAnimated--9194e";
export var submenuTitle = "submenus-module--submenuTitle--ba01e";
export var submenus = "submenus-module--submenus--bc126";